// Демо-данные глобального поиска (командной палитры) окна «Настройки».
// Страницы рабочего пространства: куда можно прыгнуть из поиска, и по каким словам их находить.
import { t } from "@/lib/i18n";

export type CommandPage = {
  id: string;
  label: string;
  icon: string;
  anchor: string;
  keywords: string;
};

export const commandPages: CommandPage[] = [
  {
    id: "page-onboarding",
    label: t("Ввод в должность"),
    icon: "ri-user-add-line",
    anchor: "#onboarding",
    keywords: t("онбординг новичок начало работы чеклист первый шаг"),
  },
  {
    id: "page-dashboard",
    label: t("Панель управления"),
    icon: "ri-dashboard-line",
    anchor: "#dashboard",
    keywords: t("дашборд dashboard показатели обзор"),
  },
  {
    id: "page-inbox",
    label: t("Входящие"),
    icon: "ri-inbox-line",
    anchor: "#inbox-app",
    keywords: t("inbox диалоги чаты переписка беседы"),
  },
  {
    id: "page-contacts",
    label: t("Контакты"),
    icon: "ri-contacts-book-2-line",
    anchor: "#contacts-app",
    keywords: t("клиенты база контактов телефон почта"),
  },
  {
    id: "page-ai-agents",
    label: t("Агенты искусственного интеллекта"),
    icon: "ri-robot-2-line",
    anchor: "#ai-agents",
    keywords: t("ai агенты боты искусственный интеллект автоматизация"),
  },
  {
    id: "page-broadcasts",
    label: t("Трансляции"),
    icon: "ri-mail-send-line",
    anchor: "#broadcasts",
    keywords: t("рассылки трансляции broadcasts сообщения клиентам"),
  },
  {
    id: "page-workflows",
    label: t("Рабочие процессы"),
    icon: "ri-flow-chart",
    anchor: "#workflows",
    keywords: t("workflow автоматизация сценарии процессы"),
  },
  {
    id: "page-reports",
    label: t("Отчеты"),
    icon: "ri-bar-chart-2-line",
    anchor: "#reports",
    keywords: t("отчеты аналитика статистика цифры"),
  },
  {
    id: "page-settings",
    label: t("Настройки рабочего пространства"),
    icon: "ri-settings-3-line",
    anchor: "#settings",
    keywords: t("настройки settings рабочее пространство"),
  },
  {
    id: "page-channels",
    label: t("Каналы"),
    icon: "ri-share-forward-line",
    anchor: "#channels",
    keywords: t("каналы whatsapp telegram подключение"),
  },
  {
    id: "page-catalog",
    label: t("Каталог каналов"),
    icon: "ri-store-2-line",
    anchor: "#catalog",
    keywords: t("каталог провайдеры sms телефония почта"),
  },
  {
    id: "page-ai-assist",
    label: "AI Assist",
    icon: "ri-sparkling-line",
    anchor: "#ai-assist",
    keywords: t("ии ассистент подсказки ответы"),
  },
  {
    id: "page-knowledge",
    label: t("Источники знаний AI"),
    icon: "ri-book-open-line",
    anchor: "#ai-knowledge",
    keywords: t("база знаний документы статьи источники"),
  },
  {
    id: "page-prompts",
    label: "AI Prompts",
    icon: "ri-question-answer-line",
    anchor: "#ai-prompts",
    keywords: t("промпты правила тон текста перевод"),
  },
  {
    id: "page-fields",
    label: t("Поля контактов"),
    icon: "ri-input-field",
    anchor: "#fields",
    keywords: t("поля карточка клиента атрибуты"),
  },
  {
    id: "page-lifecycle",
    label: t("Жизненный цикл"),
    icon: "ri-refresh-line",
    anchor: "#lifecycle",
    keywords: t("этапы воронка сделки лиды"),
  },
  {
    id: "page-conversations",
    label: t("Диалоги"),
    icon: "ri-chat-3-line",
    anchor: "#conversations",
    keywords: t("автозакрытие категории тональность"),
  },
  {
    id: "page-snippets",
    label: t("Шаблоны ответов"),
    icon: "ri-file-copy-2-line",
    anchor: "#snippets",
    keywords: t("шаблоны сниппеты быстрые ответы"),
  },
  {
    id: "page-tags",
    label: t("Теги"),
    icon: "ri-price-tag-3-line",
    anchor: "#tags",
    keywords: t("теги метки категории диалогов"),
  },
  {
    id: "page-widgets",
    label: t("Виджеты для сайта"),
    icon: "ri-layout-grid-line",
    anchor: "#widgets",
    keywords: t("виджеты сайт кнопка чат"),
  },
  {
    id: "page-email",
    label: t("Подключение почты"),
    icon: "ri-mail-line",
    anchor: "#email",
    keywords: t("почта gmail ящик imap"),
  },
  {
    id: "page-import",
    label: t("Импорт контактов"),
    icon: "ri-upload-cloud-2-line",
    anchor: "#contacts-import",
    keywords: t("импорт csv загрузка базы"),
  },
  {
    id: "page-export",
    label: t("Экспорт данных"),
    icon: "ri-download-cloud-2-line",
    anchor: "#data-export",
    keywords: t("экспорт выгрузка csv данные"),
  },
  {
    id: "page-users",
    label: t("Настройки пользователей"),
    icon: "ri-user-settings-line",
    anchor: "#user-settings",
    keywords: t("пользователи доступы приглашение роли"),
  },
  {
    id: "page-teams",
    label: t("Настройки команды"),
    icon: "ri-team-line",
    anchor: "#team-settings",
    keywords: t("команды сотрудники группы"),
  },
  {
    id: "page-general",
    label: t("Общие сведения"),
    icon: "ri-information-line",
    anchor: "#general-settings",
    keywords: t("тайм-аут дайджест часовой пояс"),
  },
  {
    id: "page-dialogs",
    label: t("Живой макет переписки"),
    icon: "ri-chat-smile-2-line",
    anchor: "#inbox",
    keywords: t("диалоги макет чат переписка"),
  },
];

// Быстрые команды палитры — показываются в группе «Команды».
export const commandActions = [
  { id: "act-new-dialog", label: t("Начать новую беседу"), icon: "ri-chat-new-line", keywords: t("создать беседа диалог новый") },
  { id: "act-new-broadcast", label: t("Создать рассылку"), icon: "ri-send-plane-line", keywords: t("создать рассылка трансляция") },
  { id: "act-invite", label: t("Пригласить пользователя"), icon: "ri-user-add-line", keywords: t("пригласить сотрудник доступ") },
  { id: "act-add-channel", label: t("Добавить канал"), icon: "ri-plug-line", keywords: t("подключить канал номер") },
];